import backgroundImage from '@/media/MultiAgentsHome/background-image.png';
import styled, { css } from 'styled-components';

export const StyledContainer = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.neutral.highPure};
    background-image: url('${backgroundImage}');
    background-position: bottom;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 24px;
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 24px;
  `}
`;


export const TitleRow = styled.div`
  ${() => css`
    display: flex;
    justify-content: space-between;
    flex-direction: row;
  `}
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.bold};
    line-height: ${theme.v2.font.lineHeight.title};
    margin: 0px;
  `}
`;


export const FirstRowImageWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 40px;
    overflow: hidden;
`;

export const MiddleImage = styled.img`
    ${({ $visible }) => css`
      max-width: 160px;
      position: relative;
      transform: translate(0px, ${$visible ? '0' : '100%'});
      transition: transform 0.5s ease-in-out;
      width: 100%;
      z-index: 3;
    `}
`;
export const LeftImage = styled.img`
    ${({ $visible }) => css`
      max-width: 160px;
      position: relative;
      transform: translate(70px, ${$visible ? '0' : '100%'});
      transition: transform 0.5s ease-in-out;
      width: 100%;
      z-index: 0;
    `}
`;
export const RightImage = styled.img`
    ${({ $visible }) => css`
      max-width: 160px;
      position: relative;
      transform: translate(-70px, ${$visible ? '0' : '100%'});
      transition: transform 0.5s ease-in-out;
      width: 100%;
      z-index: 0;
    `}
`;

export const ImageDescription = styled.span`
    ${({ theme }) => css`
      color: ${theme.v2.colors.brand.snappyBlue[5]};
      font-family: ${theme.v2.font.family.primary};
      font-size: ${theme.v2.font.sizes.xs};
      font-weight: ${theme.v2.font.weights.medium};
      line-height: ${theme.v2.font.lineHeight.text};
      text-align: center;
      margin-top: 16px;
    `};
`;


export const SecondTitle = styled.h3`
    ${({ theme }) => css`
      color: ${theme.v2.colors.brand.snappyBlue[5]};
      font-family: ${theme.v2.font.family.primary};
      font-size: ${theme.v2.font.sizes.xl};
      font-weight: ${theme.v2.font.weights.medium};
      line-height: ${theme.v2.font.lineHeight.text};
      text-align: center;
      margin: 16px auto 0px;
      max-width: 700px;

      span {
        font-weight: ${theme.v2.font.weights.bold};
        background: linear-gradient(90deg, ${theme.v2.colors.accent.pink[50]} 0%, ${theme.v2.colors.brand.snappyDarkOrange[70]} 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    `};
`;

export const Description = styled.span`
    ${({ theme }) => css`
      color: ${theme.v2.colors.neutral.lowPure};
      font-family: ${theme.v2.font.family.primary};
      font-size: ${theme.v2.font.sizes.xs};
      font-weight: ${theme.v2.font.weights.regular};
      line-height: ${theme.v2.font.lineHeight.text};
      text-align: center;
      margin: 16px auto 0px;
      max-width: 600px;
    `};
`;


export const ButtonWrapper = styled.div`
  position: relative;
  display: inline-block;
  width: fit-content;
  margin: 40px auto 0px;

  &::before {
    content: '';
    position: absolute;
    inset: 0px;
    border-radius: 100px;
    background: linear-gradient(
      90deg,
      ${({ theme }) => theme.v2.colors.brand.snappyDarkOrange[70]} 0%,
      ${({ theme }) => theme.v2.colors.accent.pink[50]} 100%
    );

    filter: blur(4px);
    opacity: 0;
    transition: 0.25s ease;
    z-index: 0;
    pointer-events: none;
  }

  &:hover::before {
    opacity: 1;
  }
`;

export const StyledButton = styled.button`
  ${({ theme }) => css`
    background: linear-gradient(
      90deg,
      ${theme.v2.colors.accent.pink[50]} 0%,
      ${theme.v2.colors.brand.snappyDarkOrange[70]} 100%
    );
    align-items: center;
    border-radius: 100px;
    border: none;
    color: ${theme.v2.colors.neutral.highPure};
    cursor: pointer;
    display: flex;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.medium};
    gap: 16px;
    justify-content: center;
    padding: 17px 32px;
    position: relative;
    width: fit-content;
    z-index: 1;
  `}
`;

export const IconsWrapper = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 12px;
    justify-content: center;
`;


export const CardsWrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: 40px;
    margin: 40px auto 0px;
    max-width: 900px;
    position: relative;
    z-index: 3;
`;

export const Card = styled.div`
    ${({ theme }) => css`
      align-items: center;
      backdrop-filter: blur(15px);
      background: rgba(255, 255, 255, 0.19);
      border-radius: 16px;
      border: 0.5px solid ${theme.v2.colors.neutral.highPure};
      display: flex;
      flex-direction: column;
      gap: 4px;
      justify-content: center;
      justify-self: stretch;
      padding: 16px;
      z-index: 2;
    `};
`;

export const CardFirstRow = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.lg};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.text};
  `};
`;

export const CardDescription = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.text};
  `};
`;

export const Image = styled.img`
  display: block;
  max-width: 210px;
  position: absolute;
  right: 0;
  top: 0;
  transform: translate(52%, -80%);
  width: 100%;
  z-index: 1;
`;
